import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'CNdiscounts',
    data () {
        return {
            admin:{},
            cndiscounts: {},
            cndiscount: {},
            panelFlag: false,
            viewFlag: false,
            img_url: service.imageURL,
            count_today:0,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.cndiscount = attr2;
            }
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getCNdiscounts() {
            service.getCNdiscounts(this,0,250).then(data => {
                if(data.body.status == 200) {
                    this.cndiscounts = data.body.data;
                }
                this.count_today = data.body.data_count_today;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        updateDiscountStatus(cndiscount,index,status){
            this.$router.push('cndiscounts')
            let payload = {
                cndiscount_action: 1,//"activate-deactivate",
                cndiscount_update: status || 0,
            }
            if(payload.cndiscount_update > 0){
                service.updateCNdiscount(this,cndiscount.cndiscount_id,payload).then(data => {
                    if(data.body.status == 200) {
                        this.cndiscounts[index].cndiscount_status = status;
                    }
                    this.getCNdiscounts();
                 }).catch((err) => {
                     if(err) {
                         //toastr.error('Sorry, could not process information', 'Warning!');
                     }
                 })
            }
        }
        
        
     
    },
    created: function(){
        this.preset();
        this.getCNdiscounts();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNdiscounts/script.js